/* eslint-disable */

/** select columns of table "argo.vw_auth_user_access_token" */
export enum ArgoVwAuthUserAccessTokenSelectColumn {
  /** column name */
  Acls = 'acls',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  UserAccessTokenId = 'user_access_token_id',
  /** column name */
  UserId = 'user_id'
}

